import { useCallback, useEffect, useState } from "react";
import { Providers } from "@tripian/model";
import { providers } from "@tripian/core";

const useRadicalStorage = (cityId?: number) => {
  const [loadingStorageList, setLoadingStorageList] = useState<boolean>(false);
  const [storageList, setStorageList] = useState<
    Providers.RadicalStorage.StorageItem[]
  >([]);

  const fetchStorageList = useCallback(() => {
    if (cityId) {
      setLoadingStorageList(true);
      try {
        providers.radialStorage
          ?.getStorageList(cityId)
          .then((response: Providers.RadicalStorage.StorageResponse) => {
            try {
              if (response.data !== undefined) setStorageList(response.data);
            } catch (error) {
              console.error("Error processing storage response:", error);
            }
          })
          .catch(error => {
            console.error("Error fetching storage list:", error);
          })
          .finally(() => {
            setLoadingStorageList(false);
          });
      } catch (error) {
        console.error("Error in fetchStorageList:", error);
        setLoadingStorageList(false);
      }
    }
  }, [cityId]);

  useEffect(() => {
    fetchStorageList();
  }, [fetchStorageList]);

  return {
    loadingStorageList,
    storageList,
  };
};

export default useRadicalStorage;
